"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(value, isFeeFree, isDelivery) {
    const parsedVal = parseInt(String(value));
    //! 추후에 수수료 변경 시 백엔드와 상의 할 것!
    if (parsedVal === 0)
        return parsedVal;
    if (isFeeFree) {
        if (isDelivery) {
            return parsedVal;
        }
        else {
            let promiseFee = 500;
            return parsedVal + promiseFee;
        }
    }
    else {
        return Math.ceil((parsedVal + parsedVal * 0.05 * 1.1) / 100) * 100;
    }
}
exports.default = default_1;
